import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputDate from '../../../../../components/Inputs/LineInputDate'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import { onValidateForm } from '../../../../../shared/utility'
import {formData } from './data'
import SwitchButton from '../../../../../components/Buttons/SwitchButton'
import moment from 'moment'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_add_user, request_check_username} from '../../requests'
import { withRouter } from 'react-router'

const AddAgentModal = props => {

    const {history, open, onClose, onRequestUsers} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setForm(JSON.parse(JSON.stringify(formData)))
    }, [open])


    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        if(id === 'password') temp.passwordConfirmation.value2 = data.value
        if(id === 'username') onUsernameVerification(data.value)
        setValid(onValidateForm(temp))
        setForm(temp)
        setError(null)
    }

    const onUsernameVerification = async(data) => {
        try {
            await request_check_username(data)
        } catch (error) {
            let temp = {...form}
            temp.username.isValid = false
            temp.username.value = data
            temp.username.config.helper = 'El usuario ya existe'
            setForm(temp)
        }

    }

    const onSubmit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {}
        Object.keys(form).forEach(item => {
            if(form[item].isValid && item !== 'passwordConfirmation'){
                data2send = {...data2send, [item]: form[item].value}
            }
        })
        console.log(data2send)
        setLoading(true)
        try {
            const user_id = await request_add_user(data2send)
            history.push(`/agents/${user_id}`)
            //setLoading(false)
            onRequestUsers()
            //onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
        }
        setLoading(false)


    }
    

    return(
        <ModalBase open={open} onClose={onClose} maxWidth='sm'>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Nuevo agente</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.first_name}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.last_name}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.username}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={6}>   
                                 <LineInputSelect 
                                 data={form.user_type_id}
                                 onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.password}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.passwordConfirmation}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LineInputText 
                                data={form.email}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12} md={6}>   
                                 <LineInputSelect 
                                 data={form.gender_id}
                                 onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12} md={6}>   
                                 <LineInputSelect 
                                 data={form.status}
                                 onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12} md={6}>   
                                 <LineInputSelect 
                                 data={form.timezone}
                                 onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton label='Agregar' error={error} loading={loading} onSubmit={onSubmit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default withRouter(AddAgentModal)